module.exports = __webpack_public_path__ + "img/antes_despues_182.549f6d49.png";